import { Box, Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import {
  setActivePanel,
  setMultipleViewMode,
} from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { useComparisonMode } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { skyLightest } from '../../../../styles/design-tokens';
import { Select } from '../../../../ui-library/select/select';
import { Text } from '../../../../ui-library/typography/typography';
import { SmallSquareButton } from '../../../../components/small-square-button/small-square-button';
import { useMultipleViewModeOptions } from '../../process-analysis.hooks';
import { ComparisonMode, type MultipleViewMode } from '../../process-analysis.type';

export const FiltersHeader = () => {
  const i18n = useTranslation();
  const comparisonMode = useComparisonMode();
  const multipleViewMode = useProcessAnalysisStore((state) => state.multipleViewMode);
  const multipleViewModeOptions = useMultipleViewModeOptions();

  const title =
    comparisonMode === ComparisonMode.Single ? (
      <Text size="medium" weight="bold" style={{ lineHeight: '32px' }}>
        {i18n.t('process_analysis.view_mode.measure_comparison')}
      </Text>
    ) : (
      <Select
        size="sm"
        options={multipleViewModeOptions}
        value={multipleViewMode}
        onChange={(value) => setMultipleViewMode(value as MultipleViewMode)}
      />
    );

  return (
    <Flex gap={8}>
      <Box style={{ flex: 1 }}>{title}</Box>
      <SmallSquareButton
        onClick={() => setActivePanel(null)}
        iconName="arrow_back_ios"
        style={{ backgroundColor: skyLightest }}
      />
    </Flex>
  );
};
